<ng-container *transloco="let t; prefix: 'PremiseHazard'">
  <!-- TODO: Test the Address Lookup (suggest) dialog: typing suggestions, validate, cancel, advanced search jump. -->
  <div class="msi-content-modal-item">
    <app-suggest-control (AddressSelectedEvent)="onSuggestAddressSelected($event)"></app-suggest-control>
    <div style="min-height: 200px"></div>
  </div>
  @if (processing) {
    <div class="justify-content-center">
      <p-progress-spinner />
    </div>
  } @else {
    <div class="flex-container-row" style="gap: 12px;">
      <div class="flex-container-column">
        <button type="button" pButton (click)="onValidate()" [disabled]="!validAddress">
          <msi-icon name="ic_search" />{{ t('Item.modal.lookup.validateButton') }}
        </button>
      </div>
      <div class="flex-container-column">
        <button type="button" pButton [outlined]="true" (click)="onCancel()">
          <msi-icon name="ic_remove" class="delete-icon" />{{ 'Buttons.cancel' | transloco }}
        </button>
      </div>
      <div class="flex-container-column">
        <button type="button" pButton [outlined]="true" (click)="onAdvancedSearch()">
          <msi-icon name="ic_location_pin" style="color: green" />{{ t('Item.modal.lookup.advancedSearchButton') }}
        </button>
      </div>
    </div>
  }
</ng-container>
